//物业区域ID
const wyqyId = "17014009578135552"; //  测试

export default wyqyId;
